import { Component, OnInit } from '@angular/core';
import { PerfilService } from './perfil.service';
import { PrestadorModel } from 'src/app/shared/models/prestador.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalActividadEconomicaComponent } from '../../layouts/modal-actividad-economica/modal-actividad-economica.component';
import { ModalEditarPerfilComponent } from '../../layouts/modal-editar-perfil/modal-editar-perfil.component';
import { ActividadEconomicaEntry } from 'src/app/shared/entrys/actividad-economica.entry';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { AlertType } from 'src/app/shared/models/alert.model';
import { PrestadorEntry } from 'src/app/shared/entrys/prestador.entry';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { EstablecimientoComercioService } from '../../../core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { ModalAjusteRntComponent } from 'src/app/components/core/layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';
import { Router } from '@angular/router';
import { UtilService } from '../../../../shared/services/util.service';

@Component({
	selector: 'app-perfil',
	templateUrl: './perfil.component.html',
	styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {
	prestadorModel: PrestadorModel;
	rolUser: string;
	seMuestraModalContrasena: boolean = false;
	tipo_prestador = RolesUsuario.Prestador;
	tipo_administrador_cc = RolesUsuario.AdministradorCC;
	tipo_administrador_super = RolesUsuario.AdministradorSuper;
	tipo_prestador_no_comerciante = TipoPrestador.Guia;

	constructor(private perfilService: PerfilService, public authService: AuthService,private router: Router,
		private modalService: NgbModal, private alertsService: AlertsService,private dataSharedService: DataSharedService,
		private establecimientoComercioService: EstablecimientoComercioService) {
		this.prestadorModel = new PrestadorModel();
		
	}

	ngOnInit() {
		this.cargarDatosperfil();
		
	}

	cargarDatosperfil() {
		this.perfilService.get(this.authService.getUserNameToken()).subscribe(resultado => {
			if (resultado.result) {
				this.prestadorModel = resultado.data as PrestadorModel;
				this.prestadorModel.usuario = this.authService.getUserNameToken();
			}
		});
	}
	onOpenModalProfile() {
		
		const modalRef = this.modalService.open(ModalEditarPerfilComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop',backdrop: "static" });
		modalRef.componentInstance.prestadorModel = this.prestadorModel;
		modalRef.result.then(resultado => {
			if (resultado.opc === 1) {
				this.actualizarDatos(resultado.data);
			} else {
				this.cambiarContrasena(resultado.data);
			}
		});
	}
	
	actualizarDatos(data: any): void {
		this.perfilService.
		update(this.getRequestActualizarDatos(data))
		.subscribe(resultado => {
			if (resultado.result) {
				this.alertsService.alert(resultado.control.alert_type as AlertType,
					'Datos actualizados exitosamente.', '/perfil/', resultado.control.code.toString());
				this.prestadorModel = { ...this.prestadorModel, ...data };
			}
		});
		this.ngOnInit();
	}

	cambiarContrasena(data: any): void {
		this.perfilService.updateCambiarClave({
			clave_acceso: UtilService.encrypt(data.clave_acceso),
			clave_acceso_anterior: UtilService.encrypt(data.clave_acceso_anterior),
			clave_acceso_confirmacion: UtilService.encrypt(data.clave_acceso_confirmacion),
		}).subscribe(resultado => {
			if (resultado.result) {
				if(this.seMuestraModalContrasena){
					this.modalService.dismissAll();
					this.seMuestraModalContrasena = false;
				}
				this.alertsService.alert(resultado.control.alert_type as AlertType,
					'contraseña actualizada exitosamente.', '/perfil/', resultado.control.code.toString());
			}
		});
	}

	consultarActividades() {
		this.perfilService.getActividadesEconomicas(null).subscribe(resultado => {
			if (resultado.result) {
				const actividadesEconomicas = resultado.data as Array<ActividadEconomicaEntry>;
				const modalRef = this.modalService.open(ModalActividadEconomicaComponent,
					{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
				modalRef.componentInstance.actividadesEconomicas = actividadesEconomicas;
			}
		});
	}

	private getRequestActualizarDatos(data:any) : PrestadorEntry {
		let correo_electronico = data.correo_electronico; 
		const patrimonio_neto = data.patrimonio_neto,
			telefono_reportado_1 = data.telefono_reportado_1,
			telefono_reportado_2 = data.telefono_reportado_2,
			es_caja_compensacion = data.es_caja_compensacion,
			numero_certificado = data.numero_certificado;

		if (data.correo_electronico === this.prestadorModel.correo_electronico) {
			correo_electronico = null;
		}
		
		return { 
			patrimonio_neto, 
			telefono_reportado_1, 
			telefono_reportado_2, 
			correo_electronico,
			es_caja_compensacion,
			numero_certificado
		} as PrestadorEntry
	}
}
